





























import { Component, Mixins } from 'vue-property-decorator'

import CategorySelect from '@/components/CategorySelect.vue'
import ItemSelect from '@/components/ItemSelect.vue'
import OrderItemSelect from '@/components/OrderItemSelect.vue'
import TheStory from '@/components/TheStory.vue'
import { CURRENT_USER } from '@/gql/auth'
import { CREATE_FEED } from '@/gql/feed'
import { Common, Upload } from '@/mixins'

@Component({
  components: {
    CategorySelect,
    ItemSelect,
    OrderItemSelect,
    TheStory
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    }
  }
})
export default class extends Mixins(Common, Upload) {
  currentUser: { id: string } | null = null
  itemIds = []
  itemIdsRecomm = []
  file: File | null = null
  title = ''
  text = ''
  comments = {}

  async submit () {
    if (!this.file) return

    await this.showLoading()
    try {
      const filename = await this.uploadFile(this.file)
      const { data } = await this.$apollo.mutate({
        mutation: CREATE_FEED,
        variables: {
          input: {
            medias: [{ type: 'VIDEO', filename }],
            title: this.title,
            text: this.text,
            feedItemInputs: [
              ...this.itemIds.map(itemId => ({
                itemId,
                comment: this.comments[itemId] || undefined,
                type: 'NORMAL'
              })),
              ...this.itemIdsRecomm.map(itemId => ({
                itemId,
                comment: this.comments[itemId] || undefined,
                type: 'ADDITIONAL'
              }))
            ]
          }
        }
      })

      this.evictApolloCache(`createdFeedConnection({"userId":${this.currentUser?.id}})`)
      await this.showToast(data.createFeed.message)
    } finally {
      await this.dismissLoading()
    }
    this.$router.back()
  }
}
